import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const TeacherProfile = () => {
  const routes = all_routes;

  const teacherData = {
    firstName: "Sarah",
    lastName: "Johnson",
    email: "sarah.johnson@school.edu",
    phone: "+1 234 567 8900",
    subject: "Mathematics",
    department: "Science & Mathematics",
    employeeId: "TCH001",
    joinDate: "2016-08-15",
    qualification: "M.Ed Mathematics, B.Sc Mathematics",
    experience: "8 years",
    bio: "Passionate mathematics teacher with 8 years of experience in secondary education. Specializes in algebra and geometry with innovative teaching methods.",
    avatar: "assets/img/profiles/avatar-teacher.jpg",
  };

  const classesData = [
    {
      grade: "10A",
      subject: "Mathematics",
      students: 30,
      schedule: "Mon, Wed, Fri - 10:00 AM",
    },
    {
      grade: "11B",
      subject: "Physics",
      students: 28,
      schedule: "Tue, Thu - 2:00 PM",
    },
    {
      grade: "9C",
      subject: "Mathematics",
      students: 32,
      schedule: "Mon, Wed - 11:00 AM",
    },
  ];

  const achievementsData = [
    {
      title: "Best Teacher Award",
      year: "2023",
      description: "Excellence in Mathematics Education",
    },
    {
      title: "Innovation in Teaching",
      year: "2022",
      description: "Digital Learning Integration",
    },
    {
      title: "Student Favorite",
      year: "2021",
      description: "Highest student ratings",
    },
  ];

  const statsData = {
    totalStudents: 90,
    averageGrade: 85.6,
    attendanceRate: 94.2,
    assignmentsGiven: 156,
    parentMeetings: 42,
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Profile Header */}
          <div className="card mb-4">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-auto">
                  <div className="avatar avatar-xxl">
                    <img
                      src={teacherData.avatar}
                      alt={`${teacherData.firstName} ${teacherData.lastName}`}
                      className="img-fluid rounded-circle"
                      onError={(e) => {
                        e.currentTarget.style.display = "none";
                        const nextSibling = e.currentTarget
                          .nextElementSibling as HTMLElement;
                        if (nextSibling) {
                          nextSibling.style.display = "flex";
                        }
                      }}
                    />
                    <div
                      className="avatar avatar-xxl bg-primary d-none align-items-center justify-content-center"
                      style={{ fontSize: "2rem", color: "white" }}
                    >
                      {teacherData.firstName[0]}
                      {teacherData.lastName[0]}
                    </div>
                  </div>
                </div>
                <div className="col">
                  <h3 className="mb-1">
                    {teacherData.firstName} {teacherData.lastName}
                  </h3>
                  <p className="text-muted mb-2">
                    {teacherData.subject} Teacher
                  </p>
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    <span className="badge bg-primary">
                      {teacherData.department}
                    </span>
                    <span className="badge bg-secondary">
                      ID: {teacherData.employeeId}
                    </span>
                    <span className="badge bg-success">
                      {teacherData.experience} Experience
                    </span>
                  </div>
                  <div className="d-flex gap-2">
                    <Link
                      to="/teacher/settings"
                      className="btn btn-primary btn-sm"
                    >
                      <i className="ti ti-edit me-1"></i>
                      Edit Profile
                    </Link>
                    <button className="btn btn-outline-secondary btn-sm">
                      <i className="ti ti-download me-1"></i>
                      Export
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="row mb-4">
            <div className="col-md-2 col-sm-6 mb-3">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-primary-transparent mx-auto mb-2">
                    <i className="ti ti-users text-primary"></i>
                  </div>
                  <h5 className="text-primary">{statsData.totalStudents}</h5>
                  <small>Total Students</small>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-6 mb-3">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-success-transparent mx-auto mb-2">
                    <i className="ti ti-chart-line text-success"></i>
                  </div>
                  <h5 className="text-success">{statsData.averageGrade}%</h5>
                  <small>Avg Grade</small>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-6 mb-3">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-info-transparent mx-auto mb-2">
                    <i className="ti ti-calendar-check text-info"></i>
                  </div>
                  <h5 className="text-info">{statsData.attendanceRate}%</h5>
                  <small>Attendance</small>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-6 mb-3">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-warning-transparent mx-auto mb-2">
                    <i className="ti ti-book text-warning"></i>
                  </div>
                  <h5 className="text-warning">{statsData.assignmentsGiven}</h5>
                  <small>Assignments</small>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-6 mb-3">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-purple-transparent mx-auto mb-2">
                    <i className="ti ti-message text-purple"></i>
                  </div>
                  <h5 className="text-purple">{statsData.parentMeetings}</h5>
                  <small>Meetings</small>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Personal Information */}
            <div className="col-md-6 mb-4">
              <div className="card h-100">
                <div className="card-header">
                  <h5 className="card-title mb-0">Personal Information</h5>
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <label className="text-muted small">Email</label>
                    <p className="mb-0">{teacherData.email}</p>
                  </div>
                  <div className="mb-3">
                    <label className="text-muted small">Phone</label>
                    <p className="mb-0">{teacherData.phone}</p>
                  </div>
                  <div className="mb-3">
                    <label className="text-muted small">Join Date</label>
                    <p className="mb-0">
                      {new Date(teacherData.joinDate).toLocaleDateString()}
                    </p>
                  </div>
                  <div className="mb-3">
                    <label className="text-muted small">Qualification</label>
                    <p className="mb-0">{teacherData.qualification}</p>
                  </div>
                  <div className="mb-0">
                    <label className="text-muted small">Bio</label>
                    <p className="mb-0">{teacherData.bio}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Current Classes */}
            <div className="col-md-6 mb-4">
              <div className="card h-100">
                <div className="card-header">
                  <h5 className="card-title mb-0">Current Classes</h5>
                </div>
                <div className="card-body">
                  {classesData.map((cls, index) => (
                    <div key={index} className="d-flex align-items-center mb-3">
                      <div className="avatar avatar-sm bg-primary-transparent me-3">
                        <span className="text-primary fw-bold">
                          {cls.grade}
                        </span>
                      </div>
                      <div className="flex-fill">
                        <h6 className="mb-1">{cls.subject}</h6>
                        <p className="text-muted mb-0 small">
                          {cls.students} students • {cls.schedule}
                        </p>
                      </div>
                      <Link
                        to="/teacher/classes"
                        className="btn btn-sm btn-outline-primary"
                      >
                        View
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Achievements */}
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Achievements & Recognition</h5>
            </div>
            <div className="card-body">
              <div className="row">
                {achievementsData.map((achievement, index) => (
                  <div key={index} className="col-md-4 mb-3">
                    <div className="card border h-100">
                      <div className="card-body text-center">
                        <div className="avatar avatar-lg bg-warning-transparent mx-auto mb-3">
                          <i className="ti ti-award text-warning fs-2"></i>
                        </div>
                        <h6 className="mb-2">{achievement.title}</h6>
                        <span className="badge bg-secondary mb-2">
                          {achievement.year}
                        </span>
                        <p className="text-muted small mb-0">
                          {achievement.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherProfile;
